import styled from '@emotion/styled'
import { colors, typography } from '@resiliatech/birdsong'
import { Typography } from '@mui/material'

export const AddChartDataModalContainer = styled.div`
  background-color: ${colors.background.secondaryBackground};
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 40px;
  width: 688px;
`

export const Header = styled(Typography)`
  ${typography.up2.semiBoldSans};
`

export const Inputs = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  height: 100%;
  padding: 20px 0;
`

export const Buttons = styled.div`
  display: flex;
  gap: 24px;
  justify-content: flex-end;
  padding-top: 20px;
`
